import React, { useState } from 'react'


const ColorSettingsModal = ({ isOpen, onClose, currentSettings, onSave, onReset }) => {
  // Estados locales para los inputs de color
  const [colors, setColors] = useState(currentSettings || {
    base: '#ffffff',
    fill: '#ffd400',
    stroke: '#000000'
  });

  if (!isOpen) return null;

  const handleChange = (key, value) => {
    setColors(prev => ({ ...prev, [key]: value }));
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000}}>
      <div style={{ background: '#fff', padding: 20, borderRadius: 8, width: 300, boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}>
        <h3 style={{ margin: '0 0 15px 0', fontSize: 18 }}>Configurar Colores</h3>

        {/* Color Base (Texto sin cantar) */}
        <div style={{ marginBottom: 15 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 'bold', marginBottom: 5 }}>Color Base (Texto)</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <input type="color" value={colors.base} onChange={(e) => handleChange('base', e.target.value)} style={{ cursor: 'pointer' }}/>
            <span style={{ fontSize: 12, fontFamily: 'monospace' }}>{colors.base}</span>
          </div>
        </div>

        {/* Color Relleno (Texto cantado) */}
        <div style={{ marginBottom: 15 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 'bold', marginBottom: 5 }}>Color Relleno (Progreso)</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <input type="color" value={colors.fill} onChange={(e) => handleChange('fill', e.target.value)} style={{ cursor: 'pointer' }}/>
            <span style={{ fontSize: 12, fontFamily: 'monospace' }}>{colors.fill}</span>
          </div>
        </div>

        {/* Color Borde (Stroke) */}
        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 'bold', marginBottom: 5 }}>Color Borde</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <input type="color" value={colors.stroke} onChange={(e) => handleChange('stroke', e.target.value)} style={{ cursor: 'pointer' }}/>
            <span style={{ fontSize: 12, fontFamily: 'monospace' }}>{colors.stroke}</span>
          </div>
        </div>

        {/* BOTÓN NUEVO: RESET */}
        {onReset && (
          <button onClick={() => { onReset(); onClose(); }} style={{ padding: '8px 12px', border: '1px solid #999', background: '#eee', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>Reestablecer</button>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button onClick={onClose} style={{ padding: '8px 12px', border: '1px solid #ccc', background: 'transparent', borderRadius: 4, cursor: 'pointer' }}>Cancelar</button>
          <button onClick={() => { onSave(colors); onClose(); }} style={{ padding: '8px 12px', border: 'none', background: '#007bff', color: '#fff', borderRadius: 4, cursor: 'pointer' }}>Guardar</button>
        </div>
      </div>
    </div>
  );
};

export { ColorSettingsModal };










// Funcional
// import React, { useState } from 'react'


// const ColorSettingsModal = ({ isOpen, onClose, currentSettings, onSave, onReset }) => {
//   // Estados locales para los inputs de color
//   const [colors, setColors] = useState(currentSettings || {
//     base: '#ffffff',
//     fill: '#ffd400',
//     stroke: '#000000'
//   });

//   if (!isOpen) return null;

//   const handleChange = (key, value) => {
//     setColors(prev => ({ ...prev, [key]: value }));
//   };

//   return (
//     <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000}}>
//       <div style={{ background: '#fff', padding: 20, borderRadius: 8, width: 300, boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}>
//         <h3 style={{ margin: '0 0 15px 0', fontSize: 18 }}>Configurar Colores</h3>

//         {/* Color Base (Texto sin cantar) */}
//         <div style={{ marginBottom: 15 }}>
//           <label style={{ display: 'block', fontSize: 12, fontWeight: 'bold', marginBottom: 5 }}>Color Base (Texto)</label>
//           <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//             <input type="color" value={colors.base} onChange={(e) => handleChange('base', e.target.value)} style={{ cursor: 'pointer' }}/>
//             <span style={{ fontSize: 12, fontFamily: 'monospace' }}>{colors.base}</span>
//           </div>
//         </div>

//         {/* Color Relleno (Texto cantado) */}
//         <div style={{ marginBottom: 15 }}>
//           <label style={{ display: 'block', fontSize: 12, fontWeight: 'bold', marginBottom: 5 }}>Color Relleno (Progreso)</label>
//           <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//             <input type="color" value={colors.fill} onChange={(e) => handleChange('fill', e.target.value)} style={{ cursor: 'pointer' }}/>
//             <span style={{ fontSize: 12, fontFamily: 'monospace' }}>{colors.fill}</span>
//           </div>
//         </div>

//         {/* Color Borde (Stroke) */}
//         <div style={{ marginBottom: 20 }}>
//           <label style={{ display: 'block', fontSize: 12, fontWeight: 'bold', marginBottom: 5 }}>Color Borde</label>
//           <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//             <input type="color" value={colors.stroke} onChange={(e) => handleChange('stroke', e.target.value)} style={{ cursor: 'pointer' }}/>
//             <span style={{ fontSize: 12, fontFamily: 'monospace' }}>{colors.stroke}</span>
//           </div>
//         </div>

//         {/* BOTÓN NUEVO: RESET */}
//         {onReset && (
//           <button onClick={() => { onReset(); onClose(); }} style={{ padding: '8px 12px', border: '1px solid #999', background: '#eee', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>Reestablecer</button>
//         )}

//         <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
//           <button onClick={onClose} style={{ padding: '8px 12px', border: '1px solid #ccc', background: 'transparent', borderRadius: 4, cursor: 'pointer' }}>Cancelar</button>
//           <button onClick={() => { onSave(colors); onClose(); }} style={{ padding: '8px 12px', border: 'none', background: '#007bff', color: '#fff', borderRadius: 4, cursor: 'pointer' }}>Guardar</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export { ColorSettingsModal };